import React, { useEffect, useState } from 'react';
import AppTitle from '../../../layouts/AppTitle';
import { registerBg } from '../../../../assets/images';
import { useNavigate } from 'react-router-dom';
import { registerForm } from '../../../../utils/formElements';
import renderElements from '../../../../utils/renderElements';
import { useDispatch, useSelector } from 'react-redux';
import { signinAction, signupAction } from '../../../../store/actions/AuthActions';
import CircularProgress from '@mui/material/CircularProgress';
import { toast } from 'react-toastify';

const Register = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [values, setValues] = useState({});
  const btnLoaderOne = useSelector(state => state?.app?.btnLoaderOne);
  const registrationForm = useSelector(state => state?.app?.registrationForm);

  useEffect(() => {
    if (registrationForm) {
      setValues(registrationForm);
    }
  }, []);

  const handleSubmit = e => {
    e.preventDefault();
    if (values?.password !== values?.confirmPassword) {
      return toast.error('Password & Confirm Password should be same.');
    }

    dispatch(signupAction(values, navigate));
    // dispatch(signinAction(values, navigate));
  };

  const handleChange = e => {
    setValues({ ...values, [e?.target?.name]: e?.target?.value });
  };

  return (
    <div>
      <AppTitle
        bgImg={registerBg}
        title={'Register'}
        from={'Login'}
        to={'Register'}
        link='/login'
      />

      <div className='section-padding-03 contact-section2 contact-section2_bg'>
        <div className='container custom-container'>
          <div className='row'>
            <div className='col-md-6'>
              <div className='contact-section2_content'>
                <h2 className='contact-section2__title'>Already a Customer</h2>
                <p className='contact-section2__text'>
                  By creating an account with our store, you will be able to move through the
                  checkout process faster, store multiple shipping addresses, view and track your
                  orders in your account and more.
                </p>
                <button
                  className='btn btn-secondary btn-hover-primary'
                  type='submit'
                  value='Send Massage'
                  onClick={() => navigate('/login')}
                >
                  Login
                </button>
              </div>
            </div>
            <div className='col-md-6'>
              <div className='contact-section2_formbg'>
                <h2 className='contact-section2_form__title'>Register...</h2>

                <form className='contact-section2_form' id='contact-form' onSubmit={handleSubmit}>
                  <div className='row'>
                    {registerForm?.map((element, i) => (
                      <div className='col-12 form-p'>
                        {renderElements({ element, setValues, values, handleChange })}
                      </div>
                    ))}

                    <div className='col-md-12 form-p'>
                      <div className='form-group mb-0 d-flex justify-content-center'>
                        <button
                          className='btn btn-secondary btn-hover-primary'
                          type='submit'
                          value='Send Massage'
                          disabled={btnLoaderOne}
                        >
                          {btnLoaderOne ? 'Submitting...' : 'Submit'}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <div className='form-messege'></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
